import React from 'react';
import FloatingHero from '../../../../components/user/general/banner/Banner';
import blogbanner from '../../../../assets/images/home/blogbanner.jpg';
const BlogBanner = () => {
  return (
    <>
      <FloatingHero
        title="FARMER KHOWLEDGE HUB"
        subtitle="Stay updated with the latest trends"
        backgroundImage= {blogbanner}
        darkOverlay={0.6}
      />
      {/* Rest of page content */}
    </>
  );
};

export default  BlogBanner;
